import React from 'react';
import { Plus, Minus } from 'lucide-react';
import { ScoreBadge } from './ScoreBadge';
import { PriorityBadge } from './PriorityBadge';
import { useTranslation } from '../../hooks/useTranslation';

// signals_positive/signals_negative (scoring.schema.json) — persistidos
// en el lead desde el Commit 13.4 (hueco encontrado justo antes de
// construir este componente: sin esa corrección, no habría datos reales
// que mostrar aquí).
export function ScoreBreakdown({ score, priority, scoreReason, signalsPositive, signalsNegative }) {
  const { t } = useTranslation();
  const hasSignals = (signalsPositive?.length || 0) + (signalsNegative?.length || 0) > 0;

  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
      <div className="flex items-center gap-3 mb-3">
        <ScoreBadge score={score} />
        <PriorityBadge priority={priority} />
      </div>

      {scoreReason && <p className="text-sm text-zinc-400 mb-3">{scoreReason}</p>}

      {hasSignals && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3">
          <div>
            <h4 className="text-xs font-semibold text-emerald-400 uppercase tracking-wide mb-2">
              {t('aiLeadScanner.scoreBreakdown.positive')}
            </h4>
            <ul className="space-y-1">
              {(signalsPositive || []).map((s, i) => (
                <li key={i} className="flex items-center justify-between text-sm text-zinc-300">
                  <span className="flex items-center gap-1.5">
                    <Plus className="w-3 h-3 text-emerald-400" />
                    {s.signal}
                  </span>
                  <span className="text-emerald-400 font-mono text-xs">+{s.points}</span>
                </li>
              ))}
              {(signalsPositive || []).length === 0 && (
                <li className="text-sm text-zinc-600">—</li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold text-red-400 uppercase tracking-wide mb-2">
              {t('aiLeadScanner.scoreBreakdown.negative')}
            </h4>
            <ul className="space-y-1">
              {(signalsNegative || []).map((s, i) => (
                <li key={i} className="flex items-center justify-between text-sm text-zinc-300">
                  <span className="flex items-center gap-1.5">
                    <Minus className="w-3 h-3 text-red-400" />
                    {s.signal}
                  </span>
                  <span className="text-red-400 font-mono text-xs">{s.points}</span>
                </li>
              ))}
              {(signalsNegative || []).length === 0 && (
                <li className="text-sm text-zinc-600">—</li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
